'use client';

/**
 * Meta (Facebook) Pixel——与 Studio 子应用共用同一 Pixel（见 studio/lib/analytics/meta-pixel.ts），
 * 经环境变量配置，两个应用需配同一值。未配置时 Pixel 不注入、不上报。
 * 主站布局不注入 base code，只在购买成功页按需懒加载，用于上报 Purchase 转化。
 * 注意：Conversions API 的 access token 属于服务端机密，严禁写入任何前端代码。
 */
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || '';

/**
 * 按需注入 Pixel base code 并 init（幂等）。仅生产环境生效，
 * 与布局注入的其他广告像素保持一致的环境语义。
 * fbq stub 同步就绪，调用后 window.fbq 立即可用，事件会排队等 fbevents.js 加载。
 */
export function ensureMetaPixel(): void {
  if (process.env.NODE_ENV !== 'production' || !META_PIXEL_ID) return;
  if (typeof window === 'undefined' || typeof window.fbq === 'function') return;

  type FbqStub = {
    (...args: unknown[]): void;
    callMethod?: (...args: unknown[]) => void;
    push: FbqStub;
    loaded: boolean;
    version: string;
    queue: unknown[][];
  };

  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  }) as FbqStub;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  fbq('init', META_PIXEL_ID);
}
